
"use client";

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
  }
}

/**
 * Rastreia um evento de conversão de cadastro.
 */
export const trackSignupConversion = () => {
  if (typeof window.gtag === "function") {
    window.gtag('event', 'conversion', {
        'send_to': 'AW-17515032281/Pbk9COrUkZAbENnd6J9B'
    });
    console.log("[ANALYTICS] Evento de conversão de cadastro disparado.");
  } else {
    console.warn("[ANALYTICS] gtag não está definido. O evento de conversão não pode ser disparado.");
  }
};
